module.exports = __webpack_public_path__ + "b529538b4fbc1a7ca8a4af2f5cc31f1f.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/icons/icons.eot
// module id = 379
// module chunks = 0